export default "__VITE_ASSET__d710a725__"